import React from 'react';
import { InputTextArea, useReadOnly } from '@spark';
import CopyFieldButton from './CopyFieldButton';
import FieldLabelWithHelp from './FieldLabelWithHelp';

const helpText = `Share the prompt that should be used for this teacher model.
Use '{{example}}' anywhere in your prompt where you want example data to be inserted. You can also use your own extra parameters with the format '{{extra_param}}'. If you don't use '{{example}}', it will be added automatically at the end of the prompt.`;

const PromptInput = ({
    prompt,
    onPromptChange,
    role,
    labelText = 'Prompt (Extraction instructions)',
    showHelpLink = false,
    helpLinkText = 'Help Me Write the Prompt',
    onHelpLinkClick = null,
    error = null,
}) => {
    const { readOnly } = useReadOnly();
    return (
        <div>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12 }}>
                <FieldLabelWithHelp
                    label={labelText}
                    helpText={helpText}
                    required
                    style={{ marginBottom: 0 }}
                />
                {showHelpLink && (
                    <span
                        className="fs-unmask"
                        role="button"
                        tabIndex={0}
                        style={{ color: 'var(--semantic-action-primary-content-default)', cursor: 'pointer', userSelect: 'none' }}
                        onClick={() => typeof onHelpLinkClick === 'function' && onHelpLinkClick()}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                typeof onHelpLinkClick === 'function' && onHelpLinkClick();
                            }
                        }}
                    >
                        {helpLinkText}
                    </span>
                )}
            </div>
            <div style={{ position: 'relative', marginTop: 8 }}>
                <CopyFieldButton value={prompt} />
                <InputTextArea
                    showLabel={false}
                    placeholder="Write your model prompt. e.g"
                    value={prompt || ''}
                    onChange={onPromptChange}
                    stretch
                    rows={5}
                    disabled={readOnly || role === 'Viewer'}
                    style={{ maxWidth: '100%' }}
                    aria-invalid={Boolean(error)}
                />
            </div>
            {error && (
                <div
                    className="fs-unmask"
                    role="alert"
                    style={{
                        marginTop: 8,
                        color: 'var(--semantic-content-error, #c0121f)',
                        fontSize: 12,
                        lineHeight: '18px',
                    }}
                >
                    {error}
                </div>
            )}
        </div>
    );
};

export default PromptInput;
